import "slick-carousel/slick/slick.min.js";

$(function(){
  $('[data-testimonials-slider]').slick({
    dots: true
  });

  $('[data-logos-slider]').slick({
  });

});